import { ThemeTokens } from '../index';

export const skeuomorphismTokens: ThemeTokens = {
  name: 'skeuomorphism',
  displayName: 'Certificate',
  description: 'Classic credential style with embossed textures and certificate-like appearance',
  
  surface: {
    primary: '#faf8f5', // Warm parchment
    secondary: '#f5f0e8',
    tertiary: '#ebe4d8',
    elevated: '#ffffff',
    sunken: '#e8e0d0',
  },
  
  border: {
    width: '2px',
    radius: '8px',
    color: '#d4c9b5',
    style: 'solid',
  },
  
  shadow: {
    sm: '0 1px 2px rgba(139, 119, 85, 0.12), inset 0 1px 0 rgba(255,255,255,0.8)',
    md: '0 4px 12px rgba(139, 119, 85, 0.15), 0 1px 3px rgba(139, 119, 85, 0.1), inset 0 1px 0 rgba(255,255,255,0.9)',
    lg: '0 8px 24px rgba(139, 119, 85, 0.2), 0 2px 6px rgba(139, 119, 85, 0.1), inset 0 2px 0 rgba(255,255,255,0.95)',
    inset: 'inset 0 2px 4px rgba(139, 119, 85, 0.15), inset 0 0 0 1px rgba(139, 119, 85, 0.1)',
  },
  
  typography: {
    fontFamily: '"Crimson Text", "Georgia", serif',
    headingWeight: '700',
    bodyWeight: '400',
    letterSpacing: '0.02em',
  },
  
  card: {
    background: 'linear-gradient(180deg, #fdfcfa 0%, #f8f5f0 100%)',
    border: '3px double #c9bda8',
    shadow: '0 6px 20px rgba(139, 119, 85, 0.18), inset 0 0 40px rgba(139, 119, 85, 0.03)',
    padding: '24px',
    radius: '12px',
  },
  
  button: {
    primary: 'linear-gradient(180deg, #8b6914 0%, #6b5010 100%)',
    secondary: 'linear-gradient(180deg, #f8f5f0 0%, #e8e0d0 100%)',
    border: '2px solid #a08050',
    shadow: '0 3px 8px rgba(139, 105, 20, 0.3), inset 0 1px 0 rgba(255,255,255,0.3)',
    radius: '6px',
    hoverTransform: 'translateY(-1px)',
  },
  
  effects: {
    texture: 'url("data:image/svg+xml,%3Csvg viewBox=\'0 0 200 200\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'noise\'%3E%3CfeTurbulence type=\'fractalNoise\' baseFrequency=\'0.9\' numOctaves=\'4\' stitchTiles=\'stitch\'/%3E%3C/filter%3E%3Crect width=\'100%25\' height=\'100%25\' filter=\'url(%23noise)\' opacity=\'0.03\'/%3E%3C/svg%3E")',
    gradient: 'linear-gradient(135deg, rgba(255,215,0,0.08) 0%, rgba(218,165,32,0.05) 100%)',
    overlay: 'radial-gradient(ellipse at center, transparent 0%, rgba(139, 119, 85, 0.05) 100%)',
  },
};

// Dark mode variant for skeuomorphism
export const skeuomorphismDarkTokens: Partial<ThemeTokens> = {
  surface: {
    primary: '#2a2520',
    secondary: '#352f28',
    tertiary: '#403830',
    elevated: '#3a3328',
    sunken: '#201c18',
  },
  border: {
    width: '2px',
    radius: '8px',
    color: '#5a4d3a',
    style: 'solid',
  },
  card: {
    background: 'linear-gradient(180deg, #322b22 0%, #2a2520 100%)',
    border: '3px double #5a4d3a',
    shadow: '0 6px 20px rgba(0, 0, 0, 0.4), inset 0 0 40px rgba(218, 165, 32, 0.02)',
    padding: '24px',
    radius: '12px',
  },
};
